import { initializePaddle, Paddle } from "@paddle/paddle-js";

let paddlePromise: Promise<Paddle | null> | null = null;
// for test purpose
function readEnv(name: string): string | undefined {
    const value = (process.env as Record<string, string | undefined>)[name];
    return value && value.trim() ? value.trim() : undefined;
}

export function getPaddle(): Promise<Paddle | null> {
    if (paddlePromise) return paddlePromise;

    paddlePromise = (async () => {
        const token =
            readEnv("REACT_APP_PADDLE_CLIENT_TOKEN") ||
            readEnv("VITE_PADDLE_CLIENT_TOKEN");

        const envRaw =
            readEnv("REACT_APP_PADDLE_ENVIRONMENT") ||
            readEnv("VITE_PADDLE_ENVIRONMENT") ||
            (process.env.NODE_ENV === "production" ? "production" : "sandbox");

        const environment: "sandbox" | "production" =
            envRaw.toLowerCase() === "production" ? "production" : "sandbox";

        if (!token) {
            // console.error(
            //     "[Paddle] REACT_APP_PADDLE_CLIENT_TOKEN not set. " +
            //     "Add it to your .env[.local] and restart the dev server."
            // );
            return null;
        }

        try {
            // console.log("[Paddle] Initializing with environment:", environment);
            const paddle = (await initializePaddle({
                token,
                environment,
            })) as Paddle;
            return paddle;
        } catch (err) {
            // console.error("Failed to init Paddle", err);
            // toast.error("Failed to init Paddle")
            return null;
        }
    })();

    return paddlePromise;
}
